<template>
  <section id="dice" class="dice-voting" v-if="details">
    <div class="dice-voting__row" v-if="details.dice !== undefined">
      <h4 class="dice-voting__title">Aftenbladets vurdering</h4>
      <dice-static class="dice-voting__dice" :value="details.publication" color="sa"></dice-static>
    </div>
    <div class="dice-voting__row" v-if="showAvg">
      <h4 class="dice-voting__title">Leserenes dom</h4>
      <p
        class="dice-voting__info"
        v-if="details.avg_amount > 50"
      >Snitt av {{details.avg_amount}} terningkast</p>
      <dice-static class="dice-voting__dice" :value="details.avg" color="avg"></dice-static>
    </div>
    <div class="dice-voting__row">
      <h4 class="dice-voting__title">Din dom</h4>
      <p class="dice-voting__info">Dra terning</p>
      <dice-dynamic class="dice-voting__dice" v-if="canVote" v-model="diceValue"></dice-dynamic>
      <dice-static class="dice-voting__dice" v-else :value="details.user" color="user"></dice-static>
    </div>
    <p class="dice-voting__voted" v-if="!canVote">Du har gitt terningkast <strong>{{details.user}}</strong></p>
    <span class="dice-voting__submit" :class="{'dice-voting__submit--fade' : !showSubmit}" @click="register" v-if="canVote">Registrer din dom</span>
  </section>
</template>

<script>
import { find, get } from 'lodash-es';
import { GET_ITEMS, GET_VOTES, GET_AVG } from './store';
import { mapGetters } from 'vuex';
import { registerDice, getDiceDetails } from './utils/firebase-methods';
import DiceStatic from './components/DiceStatic';
import DiceDynamic from './components/DiceDynamic';

export default {
  name: 'dice',
  props: {
    items: {
      type: String,
    },
    item: {
      type: String,
    }
  },
  data() {
    return {
      diceValue: null,
      item_id: null,
      items_id: null,
    };
  },
  computed: {
    ...mapGetters({
      getItems: GET_ITEMS,
      getVotes: GET_VOTES,
      getAvg: GET_AVG,
    }),
    showSubmit() {
      return this.diceValue > 0 && this.diceValue <= 6;
    },
    canVote() {
      return this.details.user === undefined;
    },
    showAvg() {
      return this.details && this.details.avg && this.details.avg > 0;
    },
    details() {
      return {
        ...find(this.getItems, i => {
          return i.item === this.item_id && i.items === this.items_id;
        }),
        user: get(
          find(this.getVotes, v => {
            return v.item === this.item_id && v.items === this.items_id;
          }),
          'value'
        ),
        avg: get(
          find(this.getAvg, a => {
            return a.item === this.item_id && a.items === this.items_id;
          }),
          'avg'
        ),
        avg_amount: get(
          find(this.getAvg, a => {
            return a.item === this.item_id && a.items === this.items_id;
          }),
          'avg_amount'
        ),
      };
    },
  },
  methods: {
    register() {
      registerDice(this.details, this.diceValue);
    },
  },
  mounted() {
    if(this.items && this.item) {
      this.items_id = this.items;
      this.item_id = this.item;
      getDiceDetails(this.items, this.item);
    } else {
      this.items_id = this.$root.items;
      this.item_id = this.$root.item;
    }
  },
  components: {
    DiceStatic,
    DiceDynamic,
  },
};
</script>

<style lang="scss">
@import './styles/settings';
@import './styles/reset';
.dice-voting {
  max-width: 450px;
  display: flex;
  flex-flow: column;
  font-family: 'Roboto';
  &__submit {
    color: #fff;
    cursor: pointer;
    align-self: flex-end;
    background: var(--dice-detail-color, #648ebd);
    border-radius: 0.25rem;
    padding: 0.5rem 1rem;
    font-weight: bold;
    font-size: 1rem;
    margin-top: 1rem;
    transition: opacity 0.3s ease-in-out;
    &--fade {
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  &__row {
    width: 100%;
    display: flex;
    position: relative;
    flex-flow: row wrap;
    align-content: center;
    align-items: flex-start;
    min-height: 4rem;
    &:not(:first-child) {
      margin-top: 1rem;
    }
    @include breakpoint(medium) {
      padding-right: calc(100% - 7rem);
    }
  }
  &__title {
    width: 100%;
    font-size: 1rem;
    font-weight: bold;
    margin: 0;
  }
  &__info {
    width: 100%;
    font-size: 0.8rem;
    font-weight: 100;
    margin-top: 1rem;
    margin: 1rem 0;
    color: get-color(black);
  }
  &__voted {
    text-align: center;
    font-size: 1.1rem;
    color: get-color(black);
  }
  &__dice {
    width: calc(100% - 70px);
    margin: 0 auto;
    perspective: 10000px;
    @include breakpoint(medium) {
      width: calc(100% - 8rem);
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
